export default "__VITE_ASSET__0072da7f__"